/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PressKitDocumentExtensionEnum {
    Pdf = 'pdf'
}


export function PressKitDocumentExtensionEnumFromJSON(json: any): PressKitDocumentExtensionEnum {
    return PressKitDocumentExtensionEnumFromJSONTyped(json, false);
}

export function PressKitDocumentExtensionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitDocumentExtensionEnum {
    return json as PressKitDocumentExtensionEnum;
}

export function PressKitDocumentExtensionEnumToJSON(value?: PressKitDocumentExtensionEnum | null): any {
    return value as any;
}

